/* Homepage-only adaptation of the existing Coinect rectangular grid calculator.
 * No tracking calls, dependencies, cart writes or Builder changes.
 */
(function (scope) {
  'use strict';

  function tileEstimate(length, width, percent) {
    if (![length, width].every(function (n) { return Number.isFinite(n) && n >= 0.1 && n <= 50; }) || [0, 5, 10].indexOf(percent) < 0) return null;
    // Millimetres avoid floating-point over-rounding at 0.47 m multiples.
    var columns = Math.ceil(Math.round(length * 1000) / 470);
    var rows = Math.ceil(Math.round(width * 1000) / 470);
    var base = columns * rows;
    var spares = Math.ceil(base * percent / 100);
    return { columns: columns, rows: rows, base: base, spares: spares, required: base + spares, area: length * width };
  }

  function bestPackPlan(required, sourcePacks) {
    var packs = sourcePacks.filter(function (p) {
      return [1, 5, 10, 15, 30].indexOf(p.quantity) >= 0 && Number.isSafeInteger(p.price) && p.price > 0 && typeof p.url === 'string' && /^\/products\/[a-z0-9-]+$/.test(p.url);
    });
    if (!packs.length) return null;
    var maxPack = Math.max.apply(null, packs.map(function (p) { return p.quantity; }));
    var max = required + maxPack - 1;
    var costs = new Float64Array(max + 1);
    var previous = new Int32Array(max + 1);
    costs.fill(Infinity); previous.fill(-1); costs[0] = 0;
    for (var count = 0; count <= max; count++) {
      if (!Number.isFinite(costs[count])) continue;
      packs.forEach(function (p, index) {
        var next = count + p.quantity;
        if (next <= max && costs[count] + p.price < costs[next]) {
          costs[next] = costs[count] + p.price;
          previous[next] = index;
        }
      });
    }
    var best = -1;
    for (var n = required; n <= max; n++) {
      if (Number.isFinite(costs[n]) && (best < 0 || costs[n] < costs[best])) best = n;
    }
    if (best < 0) return null;
    var quantities = new Array(packs.length).fill(0);
    for (var cursor = best; cursor > 0;) {
      var choice = previous[cursor];
      if (choice < 0) return null;
      quantities[choice]++;
      cursor -= packs[choice].quantity;
    }
    return { cost: costs[best], tiles: best, items: packs.map(function (p, i) { return { pack: p, count: quantities[i] }; }).filter(function (item) { return item.count > 0; }).sort(function (a, b) { return b.pack.quantity - a.pack.quantity; }) };
  }

  // CommonJS export is solely for the offline arithmetic checks in the package.
  if (typeof module !== 'undefined' && module.exports) module.exports = { tileEstimate: tileEstimate, bestPackPlan: bestPackPlan };
  if (!scope.document || scope.__loopsHomeProjects) return;
  scope.__loopsHomeProjects = true;

  function init(container) {
    container.querySelectorAll('[data-loops-floor-calc]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      var form = root.querySelector('[data-loops-floor-form]');
      var result = root.querySelector('[data-loops-floor-result]');
      var lengthInput = form.elements.namedItem('floor_length');
      var widthInput = form.elements.namedItem('floor_width');
      var percentInput = form.elements.namedItem('spare_percent');
      var config = { currency: 'GBP', packs: [] };
      try { config = JSON.parse(root.querySelector('[data-loops-floor-products]').textContent); } catch (error) { /* Tile estimate still works without products. */ }
      var currency = /^[A-Z]{3}$/.test(config.currency) ? config.currency : 'GBP';
      var money = new Intl.NumberFormat('en-GB', { style: 'currency', currency: currency });
      root.querySelector('[data-loops-calculate]').disabled = false;

      function paragraph(text, strong) {
        var p = document.createElement('p');
        if (strong) { var b = document.createElement('strong'); b.textContent = text; p.appendChild(b); } else p.textContent = text;
        result.appendChild(p);
      }
      function clear() { result.replaceChildren(); result.hidden = false; }
      form.addEventListener('input', function (event) {
        event.target.removeAttribute('aria-invalid');
        if (!result.hidden) { clear(); paragraph('Measurements changed. Calculate again to update your estimate.'); }
      });
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        [lengthInput, widthInput].forEach(function (input) { input.removeAttribute('aria-invalid'); });
        var invalid = [lengthInput, widthInput].find(function (input) { return !input.checkValidity(); });
        var estimate = tileEstimate(lengthInput.valueAsNumber, widthInput.valueAsNumber, Number(percentInput.value));
        clear();
        if (invalid || !estimate) {
          paragraph('Enter a length and width from 0.10 to 50.00 metres, using up to two decimal places.');
          if (invalid) { invalid.setAttribute('aria-invalid', 'true'); invalid.focus(); }
          return;
        }
        paragraph(estimate.required + ' tiles to plan for', true);
        paragraph(estimate.columns + ' × ' + estimate.rows + ' tiles = ' + estimate.base + ' tiles for the rectangular grid (' + estimate.area.toFixed(2) + ' m² floor area).' + (estimate.spares ? ' Includes ' + estimate.spares + ' extra spare tiles (' + percentInput.value + '% allowance, rounded up).' : ' No extra spare allowance added.'));
        var plan = bestPackPlan(estimate.required, Array.isArray(config.packs) ? config.packs : []);
        if (plan) {
          paragraph('Lowest price among the eligible available tile packs on this page:', true);
          var ul = document.createElement('ul');
          plan.items.forEach(function (item) {
            var li = document.createElement('li');
            var link = document.createElement('a');
            link.href = item.pack.url;
            link.textContent = item.count + ' × ' + (item.pack.quantity === 1 ? 'single tile' : 'pack of ' + item.pack.quantity);
            li.appendChild(link); ul.appendChild(li);
          });
          result.appendChild(ul);
          paragraph(plan.tiles + ' tiles supplied · ' + money.format(plan.cost / 100) + (plan.tiles > estimate.required ? ' · ' + (plan.tiles - estimate.required) + ' additional tiles from pack rounding.' : '.'), true);
          paragraph('Tile prices are before checkout discounts; availability is from when this page loaded. Check product details and stock before ordering. This plan excludes kits, trims and any additional delivery charges.');
        } else {
          paragraph('A pack price is unavailable. Browse the tile range or contact our team with this quantity.');
          var link = document.createElement('a');
          link.href = '/collections/garage-floor-tiles-heavy-duty-interlocking-flooring-for-garages-gyms-workshops';
          link.textContent = 'Browse Coinect tiles & packs →'; result.appendChild(link);
        }
        result.focus();
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}(typeof window !== 'undefined' ? window : {}));
